// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2lyQX","clinicsSelect":"styles_clinicsSelect__vWg4O"};